/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import Stack from "@mui/material/Stack";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ClearIcon from "@mui/icons-material/Clear";
import Loader from "@jumbo/components/Loader";
import Div from "@jumbo/shared/Div";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { managePriceSupplier } from "app/redux/slice/supplierSlice";
import { useSnackbar } from "notistack";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import JumboAppTextField from "@jumbo/components/JumboAppTextField";
import { getProductList } from "app/redux/slice/productSlice";

const validationSchema = Yup.object({
  priceType: Yup.string().required("Please select type"),
  amount: Yup.number()
    .nullable()
    .typeError("Amount must be a number")
    .required("Please enter value"),
});

const rowPriceSchema = Yup.number()
  .typeError("Price must be a number")
  .required("Please enter price")
  .min(0, "Price cannot be negative");

const ManagePrice = () => {
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  let { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const productData = useSelector((state) => state?.product);
  // const variantData = useSelector((state) => state?.variant);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState(-1);
  const [orderBy, setOrderBy] = useState("createdAt");
  const [productCopy, setProductCopy] = useState([]);
  let [checkboxAction, setCheckboxAction] = useState([]);

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "variant" });

  const columns = [
    {
      label: () => {
        return (
          <Checkbox
            checked={checkboxAction?.length === productData?.list?.length}
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                setCheckboxAction(
                  productData.list?.map((obj, i) => {
                    return obj._id;
                  }),
                );
              } else {
                setCheckboxAction([]);
              }
            }}
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
          />
        );
      },
      id: "actions",
      render: (elm) => {
        return (
          <Checkbox
            checked={checkboxAction.includes(elm._id)}
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkboxAction.push(elm._id);
              } else {
                checkboxAction = checkboxAction.filter(
                  (rec) => rec !== elm._id,
                );
              }
              setCheckboxAction([...checkboxAction]);
            }}
            sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
          />
        );
      },
    },
    {
      id: "name",
      label: "Product Name",
      sort: true,
    },
    { id: "prefix", label: "SKU", sort: true },
    {
      label: "Price",
      render: (elm, i) => (
        <TextField
          type="text"
          size="small"
          defaultValue={elm?.price ?? 0}
          onChange={(e) => {
            setProductCopy((prevData) =>
              prevData?.map((item, index) =>
                index === i ? { ...item, price: e.target.value } : item,
              ),
            );
          }}
        />
      ),
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 100,
      align: "right",
      render: (row, i) => (
        <>
          <LoadingButton
            variant="contained"
            size="small"
            loading={false}
            disabled={checkboxAction.length}
            loadingIndicator={<CircularProgress size={20} />}
            onClick={() => {
              try {
                rowPriceSchema.validateSync(productCopy[i].price);
              } catch (err) {
                enqueueSnackbar(err.message || "Invalid price", {
                  variant: "error",
                });
                return;
              }
              handleManagePrice({
                supplierId: id,
                productId: [row?._id],
                amount: +productCopy[i].price,
              });
            }}
          >
            Save
          </LoadingButton>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    handleManagePrice({
      supplierId: id,
      productId: checkboxAction,
      [data.priceType === "Add Fix Price" ? "fixPrice" : "pricePercentage"]:
        +data.amount,
    });
  };

  const getData = () => {
    localStorage.setItem("variant-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      // ...(productId && { productId: productId._id }),
      ...(id && { supplierId: id }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getProductList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };
  const handleManagePrice = (data) => {
    dispatch(managePriceSupplier(data))
      .unwrap()
      .then((response) => {
        if (response.status === 200) {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "success",
          });
          getData();
          setCheckboxAction([]);
        } else {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  useEffect(() => {
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      // ...(productId && { productId: productId._id }),
      ...(id && { supplierId: id }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getProductList(value));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  useEffect(() => {
    setProductCopy(productData.list);
  }, [productData.list]);

  return (
    <>
      {productData.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={5}>
                    <Typography variant={"h2"} mb={0}>
                      Manage Price
                    </Typography>
                  </Grid>

                  {checkboxAction.length > 0 && (
                    <>
                      <Grid item xs={12} sm={7}>
                        <Formik
                          initialValues={{
                            priceType: "",
                            amount: "",
                          }}
                          validationSchema={validationSchema}
                          onSubmit={(data, { setSubmitting }) => {
                            setSubmitting(true);
                            setTimeout(() => {
                              handleSubmit(data);
                              setSubmitting(false);
                            }, 1500);
                          }}
                        >
                          {({
                            isSubmitting,
                            touched,
                            errors,
                            values,
                            handleChange,
                            handleBlur,
                          }) => (
                            <Form>
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={5}>
                                  <FormControl
                                    fullWidth
                                    error={
                                      touched.priceType &&
                                      Boolean(errors.priceType)
                                    }
                                  >
                                    <InputLabel id="type-label">
                                      Type*
                                    </InputLabel>
                                    <Select
                                      name="priceType"
                                      labelId="type-label"
                                      id="priceType"
                                      value={values.priceType}
                                      label="Price Type"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      size="small"
                                    >
                                      {["Add Fix Price", "Add Percentage"].map(
                                        (val) => {
                                          return (
                                            <MenuItem value={val}>
                                              {val}
                                            </MenuItem>
                                          );
                                        },
                                      )}
                                    </Select>
                                    {touched.priceType && errors.priceType && (
                                      <FormHelperText>
                                        {errors.priceType}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <JumboAppTextField
                                    fullWidth
                                    name="amount"
                                    label="Amount Or %*"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Div>
                                    <LoadingButton
                                      type="submit"
                                      variant="contained"
                                      size="small"
                                      loading={isSubmitting}
                                      loadingIndicator={
                                        <CircularProgress size={20} />
                                      }
                                    >
                                      Update Price
                                    </LoadingButton>
                                  </Div>
                                </Grid>
                              </Grid>
                            </Form>
                          )}
                        </Formik>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Stack>
              <Table
                columns={columns}
                rows={productData.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={productData.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default ManagePrice;
